import React from "react";
import { AlertTriangle, AlertCircle, Info } from "lucide-react";

const cards = [
  { key: "critical", label: "Critical", icon: AlertTriangle, color: "red" },
  { key: "high", label: "High", icon: AlertCircle, color: "amber" },
  { key: "medium", label: "Medium", icon: Info, color: "blue" },
];

export default function HealthSummaryCards({ summary }) {
  if (!summary) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
      {cards.map(({ key, label, icon: Icon, color }) => (
        <div
          key={key}
          className={`bg-dark-300 border border-dark-50 rounded-xl p-5 flex items-center gap-4`}
        >
          <div className={`p-2 rounded-lg bg-${color}-900/20`}>
            <Icon className={`w-6 h-6 text-${color}-400`} />
          </div>
          <div>
            <div className="text-2xl font-bold font-mono">{summary[key] ?? 0}</div>
            <div className="text-xs text-gray-500">{label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
